import React from 'react';
import styled from 'styled-components';
import { media } from 'lib/style-utils';

const Wrapper = styled.div`
  display: none;
  padding-top: 80px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;

  & span {
    position: absolute;
    top: 0;
    left: 50%;
    width: 24px;
    height: 24px;
    margin-left: -12px;
    border-left: 2px solid ${props => props.color === "#ffffff" ? '#000000' : '#ffffff'};
    border-bottom: 2px solid ${props => props.color === "#ffffff" ? '#000000' : '#ffffff'};
    transform: rotate(-45deg);
    animation: down 2s infinite;
    opacity: 0;
    box-sizing: border-box;

    ${media.tablet`
      border-left: 3px solid ${props => props.color === "#ffffff" ? '#000000' : '#ffffff'};
      border-bottom: 3px solid ${props => props.color === "#ffffff" ? '#000000' : '#ffffff'};
    `}
  }

  @keyframes down {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  ${media.tablet`
    display: block;
    bottom: 60px;
    animation: scroll 2s infinite;
  `}
    ${media.mobile`
      bottom: -5px;
    `}
    ${media.iphone67p`
      bottom: 40px;
      animation: scroll 2s infinite;
    `}
    ${media.iphone67`
      bottom: 30px;
      animation: scroll 2s infinite;
  `}

  @keyframes scroll {
    0%{
      transform: translateY(0);
    }
    75% {
      transform: translateY(30px);
    }
    100%{
      transform: translateY(35px);
    }
  }
`;

const ScrollDown = ({color, onClick}) => (
  <Wrapper color={color} onClick={onClick}>
    <span></span>
  </Wrapper>
);

export default ScrollDown;



// WEBPACK FOOTER //
// ./src/components/About/ScrollDown.js